import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { postGuidanceAuditV3 } from '../../apis/guidance'
import type { GuidanceAudit } from '../../types'

// 「監査を終える」. 成功したら指導前準備を取り直す.
// 申し送りが空でなければ back は確認要点を作り直すので、 取り直しは processing を受け、
// useGuidanceQueryV3 の 2 秒ごとの GET が作り直しの完了まで追う.
export const useFinishAuditMutation = (yakurekiId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (handoverNote: string): Promise<GuidanceAudit> => {
      const response = await postGuidanceAuditV3(yakurekiId, { handoverNote })
      return response.data.audit
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.guidance.detail(yakurekiId), 'v3'],
      })
    },
  })
}
